import { accessRole } from "../../../../helpers/access_role";
import apiResponse from "../../../../services/apiResponse";
import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Table,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import { Link } from "react-router-dom";

import Shimmer from "react-shimmer-effect";

import PegawaiSideBar from "../../GlobalComponents/PegawaiSidebar";
import IndexBloc from "./Blocs/IndexBlock";
import moment from "moment";
import MinioClient from "../../../../services/minioClient";

class IndexView extends Component {
  indexBloc = new IndexBloc();
  minioClient = new MinioClient();
  constructor(props) {
    super(props);
    this.state = {
      data_status: 0,
      isLocal: null,
      employeeImageFileBaseurl: this.userdata.employee_image_file_baseurl,
      images: [{}],
      fotoabsen: [],
      defaultimgprofile: "",
      fotoprofile: "",
      downloadDoc: false,
      downloadPdf: false,
    };
  }
  userdata = JSON.parse(localStorage.getItem("userdata"));
  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  handleDownloadDRH = (uuid, type) => {
    this.indexBloc.fetchDownloadDRH({
      uuid: uuid,
      photo: this.state.defaultimgprofile,
      type: type,
    });
  };
  handleDownloadDRHdoc = (uuid, type) => {
    this.indexBloc.fetchDownloadDRHdoc({
      uuid: uuid,
      photo: this.state.defaultimgprofile,
      type: type,
    });
  };
  setFotoAbsen = (service, index) => {
    this.minioClient.get(service.absent_image_file_path).then((url) => {
      this.setState({
        fotoabsen: [...this.state.fotoabsen, url],
      });
      console.log(this.state.fotoabsen + " foto absen");
    });
  };

  componentDidMount() {
    console.log(this.state.detail);
    this.indexBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            console.log(response);
            this.minioClient
              .get(response.employee_image_file_path)
              .then((url) => {
                this.setState({
                  fotoprofile: url,
                });
                console.log(url);
              });
            this.setState({
              detail: response,
              data_status: response != null ? response.employee_status : 0,
              isLocal:
                response != null
                  ? response.employee_place_of_birth_national == "Dalam Negeri"
                    ? 1
                    : 0
                  : 0,
              defaultimgprofile:
                this.state.employeeImageFileBaseurl +
                response.employee_image_file_path,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    let peg_uuid =
      JSON.parse(localStorage.getItem("userdata")) != null
        ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
        : "";
    if (accessRole("approve")) {
      peg_uuid =
        JSON.parse(localStorage.getItem("employeeSelected")) != null
          ? JSON.parse(localStorage.getItem("employeeSelected")).employee_uuid
          : "";
    }
    //const peg_uuid = "86e6f2af-1c9a-40c1-8845-594e2e3797b3";
    this.indexBloc.fetchDetail({ uuid: peg_uuid });

    this.indexBloc.downloadDRHChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
    this.indexBloc.downloadDRHdocChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
    this.indexBloc.imagesChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              images: response,
            });
            this.state.images.map((data, index) => {
              this.setFotoAbsen(data, index);
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.indexBloc.fetchImages({ uuid: peg_uuid });
  }

  componentWillUnmount() {
    this.indexBloc.detailChannel?.unsubscribe();
    this.indexBloc.downloadDRHChannel?.unsubscribe();
    this.indexBloc.imagesChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <PegawaiSideBar active="identitas" />

              <Card className="pegawai-rightbar">
                <CardBody>
                  <div className="float-end mx-1">
                    {this.state.detail ? (
                      accessRole("read") ? (
                        <Button
                          color="danger"
                          onClick={() => {
                            this.handleDownloadDRH(
                              this.state.detail.employee_uuid
                            );
                          }}
                        >
                          Download DRH(PDF)
                        </Button>
                        // <Dropdown
                        //   isOpen={this.state.downloadDoc}
                        //   toggle={() => {
                        //     this.setState((prevState) => ({
                        //       downloadDoc: !prevState.downloadDoc,
                        //     }));
                        //   }}
                        //   className="btn-group me-2 mb-2 mb-sm-0"
                        // >
                        //   <DropdownToggle
                        //     className="btn btn-danger waves-light waves-effect dropdown-toggle"
                        //     tag="div"
                        //   >
                        //     Download DRH(PDF){" "}
                        //     <i className="mdi mdi-chevron-down ms-2" />
                        //   </DropdownToggle>

                        //   <DropdownMenu>
                        //     <DropdownItem
                        //       onClick={() => {
                        //         this.handleDownloadDRH(
                        //           this.state.detail.employee_uuid,
                        //           1
                        //         );
                        //       }}
                        //     >
                        //       Template 1
                        //     </DropdownItem>
                        //     {/* <DropdownItem
                        //         onClick={() => {
                        //             this.handleDownloadDRH(
                        //               this.state.detail.employee_uuid,
                        //               2
                        //             );
                        //         }}
                        //     >
                        //       Template 2
                        //     </DropdownItem>
                        //     <DropdownItem
                        //         onClick={() => {
                        //             this.handleDownloadDRH(
                        //               this.state.detail.employee_uuid,
                        //               3
                        //             );
                        //         }}
                        //     >
                        //       Template 3
                        //     </DropdownItem> */}
                        //   </DropdownMenu>
                        // </Dropdown>
                      ) : null
                    ) : (
                      <Shimmer>
                        <div style={{ width: "30%", height: 15 }}></div>
                      </Shimmer>
                    )}
                  </div>
                  <div className="float-end mx-1">
                    {this.state.detail ? (
                      accessRole("read") ? (
                        <Button
                          color="info"
                          onClick={() => {
                            this.handleDownloadDRHdoc(
                              this.state.detail.employee_uuid
                            );
                          }}
                        >
                          Download DRH(DOC)
                        </Button>
                        // <Dropdown
                        //   isOpen={this.state.downloadPdf}
                        //   toggle={() => {
                        //     this.setState((prevState) => ({
                        //       downloadPdf: !prevState.downloadPdf,
                        //     }));
                        //   }}
                        //   className="btn-group me-2 mb-2 mb-sm-0"
                        // >
                        //   <DropdownToggle
                        //     className="btn btn-primary waves-light waves-effect dropdown-toggle"
                        //     tag="div"
                        //   >
                        //     Download DRH(DOC){" "}
                        //     <i className="mdi mdi-chevron-down ms-2" />
                        //   </DropdownToggle>

                        //   <DropdownMenu>
                        //     <DropdownItem
                        //       onClick={() => {
                        //         this.handleDownloadDRHdoc(
                        //           this.state.detail.employee_uuid,
                        //           1
                        //         );
                        //       }}
                        //     >
                        //       Template 1
                        //     </DropdownItem>
                        //     {/* <DropdownItem
                        //         onClick={() => {
                        //             this.handleDownloadDRHdoc(
                        //               this.state.detail.employee_uuid,
                        //               2
                        //             );
                        //         }}
                        //     >
                        //       Template 2
                        //     </DropdownItem>
                        //     <DropdownItem
                        //         onClick={() => {
                        //             this.handleDownloadDRHdoc(
                        //               this.state.detail.employee_uuid,
                        //               3
                        //             );
                        //         }}
                        //     >
                        //       Template 3
                        //     </DropdownItem> */}
                        //   </DropdownMenu>
                        // </Dropdown>
                      ) : null
                    ) : (
                      <Shimmer>
                        <div style={{ width: "30%", height: 15 }}></div>
                      </Shimmer>
                    )}
                  </div>
                  <div className="float-end">
                    {this.state.detail ? (
                      accessRole("update") && this.state.data_status != 0 ? (
                        <Link to="?identitas&update">
                          <Button color="primary">Update Data</Button>
                        </Link>
                      ) : null
                    ) : (
                      <Shimmer>
                        <div style={{ width: "30%", height: 15 }}></div>
                      </Shimmer>
                    )}
                  </div>
                  <div className="float-end mx-1">
                    {this.state.detail ? (
                      accessRole("approve") && this.state.data_status == 0 ? (
                        <Link to="?identitas&approve">
                          <Button color="success">Approve</Button>
                        </Link>
                      ) : null
                    ) : (
                      <Shimmer>
                        <div style={{ width: "30%", height: 15 }}></div>
                      </Shimmer>
                    )}
                  </div>
                  <CardTitle>Identitas Pegawai</CardTitle>
                  <CardSubtitle className="mb-3">
                    {this.state.detail ? (
                      <>
                        {this.state.detail.employee_full_name !== ""
                          ? this.state.detail.employee_full_name
                          : "-"}
                      </>
                    ) : (
                      <Shimmer>
                        <div style={{ width: "30%", height: 15 }}></div>
                      </Shimmer>
                    )}
                  </CardSubtitle>

                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-4">Foto</label>
                    <Col md="8">
                      {/* DRH foto profile */}
                      {
                        this.state.detail &&
                        this.state.detail.employee_image_isminio == null ? (
                          //   this.state.detail ?
                          <>
                            <img
                              src={this.state.defaultimgprofile}
                              alt=""
                              className="avatar-lg img-thumbnail"
                              onError={() => {
                                this.setState({
                                  defaultimgprofile:
                                    "https://sim.salafiyahkajen.com/images/default-image.jpg",
                                });
                              }}
                            />
                            {/* <img src="https://sim.salafiyahkajen.com/images/default-image.jpg" alt="" className="avatar-lg img-thumbnail"/> */}
                            {/* <img src={"http://localhost:801/" + this.state.detail.employee_image_file_path} alt="" className="avatar-lg img-thumbnail"/> */}
                          </>
                        ) : (
                          //   <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                          //     this.state.detail && this.state.detail.employee_image_file_path ?
                          //       <>
                          <img
                            src={this.state.fotoprofile}
                            alt=""
                            className="avatar-lg img-thumbnail"
                          />
                        )
                        //       {/* <img src={"http://localhost:801/" + this.state.detail.employee_image_file_path} alt="" className="avatar-lg img-thumbnail"/> */}
                        //       </>
                        //   :
                        //   <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                      }
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-4">Foto Absen</label>
                    <Col md="8">
                      {
                        this.state.fotoabsen.length > 0 ? (
                          <>
                            {this.state.fotoabsen.map((data, index) => {
                              return (
                                <img
                                  src={data}
                                  alt=""
                                  className="avatar-lg img-thumbnail"
                                  style={{ marginRight: "10px" }}
                                />
                              );
                            })}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )
                        // <img src="https://sim.salafiyahkajen.com/images/default-image.jpg" alt="" className="avatar-lg img-thumbnail"/>
                      }
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kategori Pegawai</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_categories_name_full !==
                          ""
                            ? this.state.detail.employee_categories_name_full
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  {this.state.detail?.employee_categories_name_full.includes(
                    "EXTERNAL"
                  ) ? (
                    <>
                      <Row className="mb-3">
                        <label className="col-md-4">Instansi</label>
                        <Col md="8">
                          {this.state.detail ? (
                            <>
                              {this.state.detail.ministry_name !== ""
                                ? this.state.detail.ministry_name
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "50%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label className="col-md-4">
                          Tanggal Mulai Penugasan
                        </label>
                        <Col md="8">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .employee_assignment_start_date !== ""
                                ? this.dateParse(
                                    this.state.detail
                                      .employee_assignment_start_date
                                  )
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "50%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <label className="col-md-4">
                          Tanggal Selesai Penugasan
                        </label>
                        <Col md="8">
                          {this.state.detail ? (
                            <>
                              {this.state.detail
                                .employee_assignment_end_date !== ""
                                ? this.dateParse(
                                    this.state.detail
                                      .employee_assignment_end_date
                                  )
                                : "-"}
                            </>
                          ) : (
                            <Shimmer>
                              <div style={{ width: "50%", height: 15 }}></div>
                            </Shimmer>
                          )}
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-4">NIP Lama</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_nip_old !== ""
                            ? this.state.detail.employee_nip_old
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">NIP Baru</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_nip !== ""
                            ? this.state.detail.employee_nip
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Nama Lengkap</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_full_name !== ""
                            ? this.state.detail.employee_full_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Gelar Non Akademi Depan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_front_title_non_academic !== ""
                            ? this.state.detail
                                .employee_front_title_non_academic
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">
                      Gelar Non Akademi Belakang
                    </label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_end_title_non_academic !==
                          ""
                            ? this.state.detail.employee_end_title_non_academic
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Gelar Depan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_front_title !== ""
                            ? this.state.detail.employee_front_title
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Gelar Belakang</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_end_title !== ""
                            ? this.state.detail.employee_end_title
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-4">
                      Lahir Dalam / Luar Negeri
                    </label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_place_of_birth_national !== ""
                            ? this.state.detail.employee_place_of_birth_national
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Negara Lahir</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_place_of_birth_country_name !== ""
                            ? this.state.detail
                                .employee_place_of_birth_country_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row
                    className="mb-3"
                    style={this.state.isLocal == 0 ? { display: "none" } : {}}
                  >
                    <label className="col-md-4">Provinsi Lahir</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_place_of_birth_province_name !== ""
                            ? this.state.detail
                                .employee_place_of_birth_province_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row
                    className="mb-3"
                    style={this.state.isLocal == 0 ? { display: "none" } : {}}
                  >
                    <label className="col-md-4">Kota Lahir</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_place_of_birth_city_name !== ""
                            ? this.state.detail
                                .employee_place_of_birth_city_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row
                    className="mb-3"
                    style={this.state.isLocal == 1 ? { display: "none" } : {}}
                  >
                    <label className="col-md-4">Kota Lahir</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_place_of_birth_city_text !== ""
                            ? this.state.detail
                                .employee_place_of_birth_city_text
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <hr />

                  <Row className="mb-3">
                    <label className="col-md-4">Tanggal Lahir</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_date_of_birth !== ""
                            ? this.dateParse(
                                this.state.detail.employee_date_of_birth
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Jenis Kelamin</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_gender_name !== ""
                            ? this.state.detail.employee_gender_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Agama</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_religion_name !== ""
                            ? this.state.detail.employee_religion_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Status Pernikahan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_marital_status_name !== ""
                            ? this.state.detail.employee_marital_status_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Golongan darah</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_blood_type_name !== ""
                            ? this.state.detail.employee_blood_type_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-4">Alamat Tinggal</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_domicile_address !== ""
                            ? this.state.detail.employee_domicile_address
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Provinsi</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_domicile_province_name !==
                          ""
                            ? this.state.detail.employee_domicile_province_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kabupaten/Kota</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_domicile_city_name !== ""
                            ? this.state.detail.employee_domicile_city_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kecamatan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_domicile_districts_name !== ""
                            ? this.state.detail.employee_domicile_districts_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Desa/Kelurahan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_domicile_village_name !==
                          ""
                            ? this.state.detail.employee_domicile_village_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kode Pos</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_domicile_postal_code !==
                          ""
                            ? this.state.detail.employee_domicile_postal_code
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-4">Alamat KTP</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_identity_address !== ""
                            ? this.state.detail.employee_identity_address
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Provinsi</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_identity_province_name !==
                          ""
                            ? this.state.detail.employee_identity_province_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kabupaten/Kota</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_identity_city_name !== ""
                            ? this.state.detail.employee_identity_city_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kecamatan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_identity_districts_name !== ""
                            ? this.state.detail.employee_identity_districts_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Desa/Kelurahan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_identity_village_name !==
                          ""
                            ? this.state.detail.employee_identity_village_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kode Pos</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_identity_postal_code !==
                          ""
                            ? this.state.detail.employee_identity_postal_code
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <hr />
                  <Row className="mb-3">
                    <label className="col-md-4">Bank</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_bank_name !== ""
                            ? this.state.detail.employee_bank_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Rekening Gaji</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_bank_account_number !== ""
                            ? this.state.detail.employee_bank_account_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Unit Kerja</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_current_work_unit_name !==
                          ""
                            ? this.state.detail.employee_current_work_unit_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Jabatan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_current_position_name !==
                          ""
                            ? this.state.detail.employee_current_position_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Jabatan (Kemenkeu)</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_current_position_name_kemenkeu !== ""
                            ? this.state.detail
                                .employee_current_position_name_kemenkeu
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Tipe Pegawai</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_current_position_type_kemenkeu !== ""
                            ? this.state.detail
                                .employee_current_position_type_kemenkeu
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Status Pegawai</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_status_name !== ""
                            ? this.state.detail.employee_status_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Status Penggajian</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_salary_paid_from !== ""
                            ? this.state.detail.employee_salary_paid_from
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Keterangan Status</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail
                            .employee_status_description_name !== ""
                            ? this.state.detail.employee_status_description_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Tanggal Pensiun</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_date_of_pension !== ""
                            ? this.dateParse(
                                this.state.detail.employee_date_of_pension
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">TMT Pensiun</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_tmt_pension !== ""
                            ? this.dateParse(
                                this.state.detail.employee_tmt_pension
                              )
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kedudukan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_status_position_name !==
                          ""
                            ? this.state.detail.employee_status_position_name
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kartu Pegawai</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_karpeg_number !== ""
                            ? this.state.detail.employee_karpeg_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Askes / BPJS Kesehatan</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_askes_number !== ""
                            ? this.state.detail.employee_askes_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Tapera</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_tapera_number !== ""
                            ? this.state.detail.employee_tapera_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Taspen</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_taspen_number !== ""
                            ? this.state.detail.employee_taspen_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">NPWP</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_npwp_number !== ""
                            ? this.state.detail.employee_npwp_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">NIK</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_identity_number !== ""
                            ? this.state.detail.employee_identity_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">No. Dosir</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_dosir_number !== ""
                            ? this.state.detail.employee_dosir_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Telepon Rumah</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_phone_number !== ""
                            ? this.state.detail.employee_phone_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Handphone</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_mobile_phone_number !== ""
                            ? this.state.detail.employee_mobile_phone_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Email Office 365</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_email_internal !== ""
                            ? this.state.detail.employee_email_internal
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Email Eksternal</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_email_external !== ""
                            ? this.state.detail.employee_email_external
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Lokasi Kerja</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.work_unit_location_full_address !==
                          ""
                            ? this.state.detail.work_unit_location_full_address
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Nomor Enroll</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_enroll_number !== ""
                            ? this.state.detail.employee_enroll_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">ID SAPK BKN</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_sapk_bkn_id !== ""
                            ? this.state.detail.employee_sapk_bkn_id
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">File Pendukung</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.document !== null ? (
                            <a
                              target={"_blank"}
                              className="btn btn-sm btn-success"
                              href={this.state.detail.document.documents_path}
                            >
                              Download <i className="fa fa-download ms-1"></i>
                            </a>
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-4">Nomor Kartu Keluarga</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_family_card_number !== ""
                            ? this.state.detail.employee_family_card_number
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <label className="col-md-4">Kartu Keluarga</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.document_kk !== null ? (
                            <a
                              target={"_blank"}
                              className="btn btn-sm btn-success"
                              href={
                                this.state.detail.document_kk.documents_path
                              }
                            >
                              Download <i className="fa fa-download ms-1"></i>
                            </a>
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Status Approval</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.employee_status_approval_name !==
                          "" ? (
                            <label className="badge rounded-pill bg-soft-info font-size-12">
                              {this.state.detail.employee_status_approval_name}
                            </label>
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }}></div>
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kedudukan Hukum</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.legal_position_status_code !== ""
                            ? `${this.state.detail.legal_position_status_code} - ${this.state.detail.legal_position_status_name}`
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }} />
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Kode Jiwa</label>
                    <Col md="8">
                      {this.state.detail ? (
                        <>
                          {this.state.detail.dependent_status_code !== ""
                            ? `${this.state.detail.dependent_status_code} - ${this.state.detail.dependent_status_name}`
                            : "-"}
                        </>
                      ) : (
                        <Shimmer>
                          <div style={{ width: "50%", height: 15 }} />
                        </Shimmer>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Memproses data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}
export default IndexView;
